import React from 'react';

// Constants
import { ColumnsConst, GoalTableColumns } from '../GoalsTable';

// Components
import WpButton from 'Wpds/components/button/WpButton';
import { WpCheckbox } from 'Wpds/components/checkbox';
import WpIcon from 'Wpds/components/icon/WpIcon';
import {
  WpDropdown,
  WpDropdownToggle,
  WpDropdownMenu,
  WpDropdownMenuItem,
  WpDropdownMenuTitle,
} from 'Wpds/components/dropdown';

type Props = {
  hiddenColumns: Array<GoalTableColumns>;
  setHiddenColumns: Function;
};

const HideColumnDropdown = ({ hiddenColumns, setHiddenColumns }: Props) => {
  const formattedOptions = Object.entries(ColumnsConst).map(([key, value]) => ({
    key: key as GoalTableColumns,
    ...value,
  }));
  const formattedHiddenColumns: Array<GoalTableColumns> = hiddenColumns.map(hc => hc.toLowerCase() as GoalTableColumns);

  const handleToggleColumn = ({ label, value }) => {
    if (!value) {
      setHiddenColumns([...formattedHiddenColumns, label]);
    } else {
      setHiddenColumns(formattedHiddenColumns.filter(column => column !== label));
    }
  };

  return (
    <WpDropdown placement="bottom-end">
      <WpDropdownToggle>
        <WpButton variant="tertiary" size="sm">
          <WpIcon name="ellipsis-h-alt" />
        </WpButton>
      </WpDropdownToggle>
      <WpDropdownMenu>
        <WpDropdownMenuTitle title="Show/Hide Columns" />
        {Object.values(formattedOptions)
          .filter(column => column.canHide)
          .map(column => {
            const key = `column-${column.key.replace(/\s/g, '').toLocaleLowerCase()}-checkbox`;
            return (
              <WpDropdownMenuItem closeOnClick={false} key={key}>
                <WpCheckbox
                  id={key}
                  label={column.label}
                  checked={!formattedHiddenColumns.includes(column.key)}
                  onChange={value => handleToggleColumn({ label: column.key, value: value })}
                />
              </WpDropdownMenuItem>
            );
          })}
      </WpDropdownMenu>
    </WpDropdown>
  );
};

export default HideColumnDropdown;
